import Vue from "vue"

import utils from "@/utils/utils"
const state = () => ({})

const getters = {
  validationsIndex: (state) => (payload) => {
    //const { param, parent, key } = payload || {}

    return utils.digger(state, payload)
  }
}
const actions = {
  UPDATE_validations({ commit }, payload) {
    commit("SET_validations", payload)
    return true
  },
  async CLEAN_STORE_validations({ commit }) {
    const initialStateKeys = Object.keys(state)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_validations", {
          param: current,
          value: undefined
        })
        return true
      })
    )

    return true
  }
}
const mutations = {
  SET_validations: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
